// API BASE URL - always use from here
export const API_BASE_URL = process.env.REACT_APP_WEALTH_FINTAX_API_BASE_URL || "http://localhost:5053/api/";
